import gql from "graphql-tag";

export const SUBMIT = gql`
  mutation submitReview($review: ReviewInput!) {
    submitReview(review: $review)
  }
`;